module.exports = __webpack_public_path__ + "img/total-orders.79e7511a.svg";